import {course_getStudents_Api} from 'apis'
import {getId} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import ContainerPicker from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import _ from 'lodash'
import {renderIf} from "../../../Shared";

export const StudentSelector = ({
  name,
  value,
  owner_id,
  owner_type,
  onChange = NullAsDefault,
  ...props
}) => {
  const t = useTranslate()
  const defaultValue = getId(value) ?? value

  return (
    <ContainerPicker
      name={name}
      allowClear={true}
      defaultValue={defaultValue}
      type={AppEntities.UNDEFINED}
      placeholder="click to select"
      renderInnerWrapper={InnerWrapper}
      onOptionChange={(option) => {
        onChange(createValue(name, option ?? null))
      }}
      renderOption={renderBaseOption(defaultValue, (option) => {
          return ({
              title: (
                  <div className="text-sm space-x-1">
                      {renderIf(
                          _.get(option, 'patron_saint_name') || _.get(option,'prefix_title'),
                          <span className="font-medium text-color-200 italic">
                              {`${_.get(option, 'patron_saint_name') || _.get(option,'prefix_title') } `}
                          </span>
                      )}
                      <span className="font-bold text-color-000">{option?.fullname}</span>
                  </div>
              ),
              description: (
                  <div className="text-xs italic">
                      <span className="text-color-500">{`${t('student code')} : `}</span>
                      <span className="font-medium text-color-300">{_.get(option, 'student_idcode')}</span>
                  </div>
              ),
          })
      })}
      customConfigs={{
        apiInfo: course_getStudents_Api,
        query: bindQueryParams([{ id: owner_id }, { type: owner_type }]),
      }}
      {...props}
    />
  )
}
